








































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import GenericAdd from "@/core/Generics/GenericAdd";
import MemberType from "@/models/porposal/memberType.Model";
@Component
export default class MemberTypeAdd extends GenericAdd<MemberType> {
  constructor() {
    super();
    this.controller = "MemberTypes";
    this.model = new MemberType();
  }
  @Watch("model.isTheResponsableMember")
  onIsResponsableMemberChange(){
      if(this.model.isTheResponsableMember)
        this.model.isUniqueInPorposal =  true;
        else{
            this.model.isUniqueInPorposal = false;
        }

  }
}
